// ─────────────────────────────────────────────────────────────────────────
// Prim Yönetimi modülü için GraphQL mutationları.
// ─────────────────────────────────────────────────────────────────────────

// ─── Ciro Türü CRUD
export const CREATE_BONUS_REVENUE_TYPE_MUTATION = `
  mutation CreateBonusRevenueType($object: bonus_revenue_types_insert_input!) {
    insert_bonus_revenue_types_one(object: $object) {
      id name code coefficient applicable_channels
    }
  }
`;
export const UPDATE_BONUS_REVENUE_TYPE_MUTATION = `
  mutation UpdateBonusRevenueType($id: Int!, $_set: bonus_revenue_types_set_input!) {
    update_bonus_revenue_types_by_pk(pk_columns: { id: $id }, _set: $_set) {
      id name code coefficient applicable_channels
    }
  }
`;
export const DELETE_BONUS_REVENUE_TYPE_MUTATION = `
  mutation DeleteBonusRevenueType($id: Int!) {
    delete_bonus_revenue_types_by_pk(id: $id) { id }
  }
`;

// ─── Prim Ciro Kuralı CRUD
export const CREATE_BONUS_REVENUE_RULE_MUTATION = `
  mutation CreateBonusRevenueRule($object: bonus_revenue_rules_insert_input!) {
    insert_bonus_revenue_rules_one(object: $object) {
      id ciro_kanali operation aciklama
    }
  }
`;
export const UPDATE_BONUS_REVENUE_RULE_MUTATION = `
  mutation UpdateBonusRevenueRule($id: Int!, $_set: bonus_revenue_rules_set_input!) {
    update_bonus_revenue_rules_by_pk(pk_columns: { id: $id }, _set: $_set) {
      id ciro_kanali operation aciklama
    }
  }
`;
export const DELETE_BONUS_REVENUE_RULE_MUTATION = `
  mutation DeleteBonusRevenueRule($id: Int!) {
    delete_bonus_revenue_rules_by_pk(id: $id) { id }
  }
`;

// Bir ciro kuralının ekiplerini topluca güncelle (delete + insert pattern).
// Form multiselect değişiklikleri için kullanılır.
export const UPDATE_BONUS_REVENUE_RULE_TEAMS_MUTATION = `
  mutation UpdateBonusRevenueRuleTeams($ruleId: Int!, $objects: [bonus_revenue_rule_teams_insert_input!]!) {
    delete_bonus_revenue_rule_teams(where: { bonus_revenue_rule_id: { _eq: $ruleId } }) {
      affected_rows
    }
    insert_bonus_revenue_rule_teams(objects: $objects) {
      affected_rows
    }
  }
`;

// ─── Prim Kuralı CRUD
export const CREATE_BONUS_RULE_MUTATION = `
  mutation CreateBonusRule($object: bonus_rules_insert_input!) {
    insert_bonus_rules_one(object: $object) {
      id baslangic_yil baslangic_ceyrek bitis_yil bitis_ceyrek is_active
    }
  }
`;
export const UPDATE_BONUS_RULE_MUTATION = `
  mutation UpdateBonusRule($id: Int!, $_set: bonus_rules_set_input!) {
    update_bonus_rules_by_pk(pk_columns: { id: $id }, _set: $_set) {
      id is_active
    }
  }
`;
export const DELETE_BONUS_RULE_MUTATION = `
  mutation DeleteBonusRule($id: Int!) {
    delete_bonus_rules_by_pk(id: $id) { id }
  }
`;

export const UPDATE_BONUS_RULE_TEAMS_MUTATION = `
  mutation UpdateBonusRuleTeams($ruleId: Int!, $objects: [bonus_rule_teams_insert_input!]!) {
    delete_bonus_rule_teams(where: { bonus_rule_id: { _eq: $ruleId } }) {
      affected_rows
    }
    insert_bonus_rule_teams(objects: $objects) {
      affected_rows
    }
  }
`;

// ─── Kullanıcı Bazlı Prim Katsayıları CRUD (TASK B)
export const CREATE_USER_BONUS_COEFFICIENT_MUTATION = `
  mutation CreateUserBonusCoefficient($object: user_bonus_coefficients_insert_input!) {
    insert_user_bonus_coefficients_one(object: $object) {
      id user_id yil ceyrek katsayi
    }
  }
`;
export const UPDATE_USER_BONUS_COEFFICIENT_MUTATION = `
  mutation UpdateUserBonusCoefficient($id: Int!, $_set: user_bonus_coefficients_set_input!) {
    update_user_bonus_coefficients_by_pk(pk_columns: { id: $id }, _set: $_set) {
      id katsayi
    }
  }
`;
export const DELETE_USER_BONUS_COEFFICIENT_MUTATION = `
  mutation DeleteUserBonusCoefficient($id: Int!) {
    delete_user_bonus_coefficients_by_pk(id: $id) { id }
  }
`;

// Ekip + Yıl + Çeyrek bazlı toplu katsayı yazımı (bulk upsert).
// UNIQUE constraint: user_bonus_coefficients_user_id_yil_ceyrek_key
export const BULK_UPSERT_USER_BONUS_COEFFICIENTS_MUTATION = `
  mutation BulkUpsertUserBonusCoefficients(
    $objects: [user_bonus_coefficients_insert_input!]!
  ) {
    insert_user_bonus_coefficients(
      objects: $objects
      on_conflict: {
        constraint: user_bonus_coefficients_user_id_yil_ceyrek_key
        update_columns: [katsayi]
      }
    ) {
      affected_rows
      returning { id user_id yil ceyrek katsayi }
    }
  }
`;

// ─── Hedefler CRUD (TASK E)
export const CREATE_BONUS_TARGET_MUTATION = `
  mutation CreateBonusTarget($object: bonus_targets_insert_input!) {
    insert_bonus_targets_one(object: $object) {
      id yil ceyrek team_id user_id hedef_tutar
    }
  }
`;
export const UPDATE_BONUS_TARGET_MUTATION = `
  mutation UpdateBonusTarget($id: Int!, $_set: bonus_targets_set_input!) {
    update_bonus_targets_by_pk(pk_columns: { id: $id }, _set: $_set) {
      id hedef_tutar team_id user_id yil ceyrek
    }
  }
`;
export const DELETE_BONUS_TARGET_MUTATION = `
  mutation DeleteBonusTarget($id: Int!) {
    delete_bonus_targets_by_pk(id: $id) { id }
  }
`;

// ─── Prim Tahsilatı CRUD (manuel ödeme / ek prim)
export const CREATE_BONUS_PAYMENT_MUTATION = `
  mutation CreateBonusPayment($object: bonus_payments_insert_input!) {
    insert_bonus_payments_one(object: $object) {
      id user_id islem_turu tutar yil ceyrek
    }
  }
`;
export const UPDATE_BONUS_PAYMENT_MUTATION = `
  mutation UpdateBonusPayment($id: Int!, $_set: bonus_payments_set_input!) {
    update_bonus_payments_by_pk(pk_columns: { id: $id }, _set: $_set) {
      id user_id islem_turu tutar
    }
  }
`;
export const DELETE_BONUS_PAYMENT_MUTATION = `
  mutation DeleteBonusPayment($id: Int!) {
    delete_bonus_payments_by_pk(id: $id) { id }
  }
`;
